import { useMainStore } from "../../../main/store/mainStore.js";
import {
  maxDeadLetterQueueLength,
  maxLogWriteAttempts,
} from "./data/log-queue-config.js";
import { pseudoDeadLetterQueue, queue } from "./queue.js";

const retryAnnotation = (attempts) =>
  attempts > 0 ? [`[RETRY=${attempts}]`] : [];

export const drainQueue = async (idb) => {
  if (queue.length === 0) {
    return;
  }

  let connection;

  try {
    connection = await idb();
  } catch {
    return;
  }

  const retrying = queue.splice(0);

  await Promise.all(
    retrying.map(async (entry) => {
      try {
        await connection.add("logs", {
          id: entry.id,
          level: entry.level,
          args: [...retryAnnotation(entry.attempts), ...entry.args],
          timestamp: entry.timestamp,
        });
      } catch {
        if (entry.attempts + 1 >= maxLogWriteAttempts) {
          if (pseudoDeadLetterQueue.length >= maxDeadLetterQueueLength) {
            pseudoDeadLetterQueue.shift();
          }

          pseudoDeadLetterQueue.push(entry);

          useMainStore().logEntryWriteFailureCount += 1;
        } else {
          queue.push({ ...entry, attempts: entry.attempts + 1 });
        }
      }
    })
  );
};
